module.exports = __webpack_public_path__ + "static/media/slide-5r.302796f0.jpg";